import { Button } from '@cfa/react-components';
import { ErrorInfo } from 'react';

import Section from '../Section';
import SectionHeader from '../SectionHeader';

interface Props {
  error?: Error;
  info?: ErrorInfo;
  location?: Location;
}

const UnrecoverableError = ({ error, info, location = window.location }: Props): JSX.Element => {
  console.error(error, info);

  return (
    <Section>
      <SectionHeader>Oops!</SectionHeader>
      <p>There was an unrecoverable error. Please try again or contact support.</p>
      <Button color="secondary" onClick={() => location.assign(location.origin)}>
        Try Again
      </Button>
    </Section>
  );
};

export default UnrecoverableError;
